/**
 *
 * @deprecated This component is in line for removing, we should use app-typeahead instead
 */
import {
  Component,
  OnInit,
  DoCheck,
  OnChanges,
  SimpleChanges,
  Output,
  Input,
  EventEmitter,
  ViewChild,
  ElementRef,
  HostListener,
} from '@angular/core';

import { v1 as uuidv1 } from 'uuid';

import * as _ from 'lodash';

// tslint:disable-next-line:no-conflicting-lifecycle
@Component({
  selector: 'app-select-typeahead',
  templateUrl: './select-typeahead.component.html',
  styleUrls: ['./select-typeahead.component.css'],
})
// eslint-disable-next-line @angular-eslint/no-conflicting-lifecycle
export class SelectTypeaheadComponent implements OnInit, OnChanges, DoCheck {
  time_out;
  before: string;
  after: string;

  type_ahead: string;
  institutions: any = [];

  input_value_copy: any = [];

  result: any = [];
  sel = 0;

  // return_value = { key: null, value: this.type_ahead };
  return_value: any = {};

  backspace = true;
  old_value: any = [];
  old_exsisting_value: string;
  input_bottom: number;

  @Input() input_value: any = [];
  @Input() exsisting_value: string;
  @Input() placeholder: string;
  @Input() objectValue: string;
  @Input() objectKey: string;
  @Input() returnWholeObject: boolean;
  @Input() inputWidth: string;
  @Input() free_entry: boolean;
  @Input() inputStyle: string;
  @Input() isDisabled: boolean;
  containerWidth: string;

  // eslint-disable-next-line @angular-eslint/no-output-rename
  @Output() emmiterReturnString = new EventEmitter();
  // eslint-disable-next-line @angular-eslint/no-output-rename
  // tslint:disable-next-line:no-output-rename
  @Output() emmiterReturnValue = new EventEmitter();

  @ViewChild('inputfield', { static: true }) inputfield: ElementRef;
  @ViewChild('typeahead') typeahead: ElementRef;
  @ViewChild('results') results: ElementRef;
  @ViewChild('selresult') selresult: ElementRef;

  @HostListener('document:click', ['$event'])
  onClick(e) {
    if (this.results) {
      if (e.target !== this.inputfield.nativeElement && e.target !== this.results.nativeElement) {
        this.result = [];
        if (this.type_ahead === '' && this.old_exsisting_value !== '' && this.exsisting_value !== '') {
          this.return_old_value();
        } else {
          if (this.free_entry) {
            this.take_value(e);
          } else {
            this.return_old_value();
          }
        }
      }
    } else {
      if (e.target !== this.inputfield.nativeElement) {
        this.result = [];
        if (this.type_ahead === '' && this.old_exsisting_value !== '' && this.exsisting_value !== '') {
          this.return_old_value();
        } else {
          if (this.free_entry) {
            this.take_value(e);
          } else {
            this.return_old_value();
          }
        }
      }
    }
  }

  constructor() {}
  // eslint-disable-next-line @angular-eslint/no-conflicting-lifecycle
  ngOnInit() {
    this.return_value = { key: null, value: this.type_ahead };
    this.clone_value();
    this.bind_existing_value();
    this.set_type_ahead_position();
    if (!this.inputWidth || this.inputWidth === '') {
      this.inputWidth = '16.3';
      this.containerWidth = (parseFloat(this.inputWidth) + 0.5).toString();
    } else {
      this.containerWidth = (parseFloat(this.inputWidth) + 0.5).toString();
    }
  }
  // eslint-disable-next-line @angular-eslint/no-conflicting-lifecycle
  ngDoCheck() {
    if (!_.isEqual(this.old_value, this.input_value)) {
      setTimeout(() => {
        this.clone_value();
      }, 100);
    }
  }
  // eslint-disable-next-line @angular-eslint/no-conflicting-lifecycle
  ngOnChanges(changes: SimpleChanges) {
    if (changes) {
      if ('exsisting_value' in changes) {
        this.return_old_value();
        setTimeout(() => {
          this.bind_existing_value();
        }, 100);
      }
    }
  }
  set_type_ahead_position() {
    // trenutno nije u funkciji dok e odlcim gde ce bit
    let top;
    let left;
    top = this.inputfield.nativeElement.getBoundingClientRect().top + 1;
    left = this.inputfield.nativeElement.getBoundingClientRect().left + 1;
    // bottom = this.inputfield.nativeElement.getBoundingClientRect().bottom + 1;

    // this.typeahead.nativeElement.top = top;
    // this.typeahead.nativeElement.left = left;
    // this.renderer.setStyle(this.typeahead.nativeElement, 'top', top);
    // this.renderer.setStyle(this.typeahead.nativeElement, 'left', left);
  }
  set_result_position(direction) {
    const selResult = document.getElementById('selresult' + this.sel);
    const resultsBox = this.results.nativeElement;

    if (direction === 'down' && resultsBox.getBoundingClientRect().bottom < selResult.getBoundingClientRect().bottom) {
      resultsBox.scrollBy(0, selResult.getBoundingClientRect().bottom - resultsBox.getBoundingClientRect().bottom);
    }
    if (direction === 'up' && resultsBox.getBoundingClientRect().top > selResult.getBoundingClientRect().top) {
      resultsBox.scrollBy(0, selResult.getBoundingClientRect().top - resultsBox.getBoundingClientRect().top);
    }
  }
  clone_value() {
    if (this.type_ahead !== '' && this.type_ahead !== this.exsisting_value) {
      this.result = _.cloneDeep(this.input_value);
      this.old_value = _.cloneDeep(this.input_value);
    }
  }
  get_next_result(e) {
    e.stopPropagation();
    e.preventDefault();
    this.backspace = false;

    if (this.sel < this.result.length - 1) {
      this.sel = this.sel + 1;
    }
    if (this.result.length > 0 && this.type_ahead !== '') {
      this.set_result_position('down');
    }
    // this.before = this.result[this.sel].value.substring(0, this.result[this.sel].value.toLowerCase().indexOf(this.type_ahead));
    // this.after = this.result[this.sel].value.substring( (this.before.length + this.type_ahead.length) );
  }
  get_prev_results(e) {
    const bckup = this.type_ahead;
    e.stopPropagation();
    e.preventDefault();
    if (this.sel > 0) {
      this.sel = this.sel - 1;
    }
    // this.before = this.result[this.sel].value.substring(0, this.result[this.sel].value.toLowerCase().indexOf(this.type_ahead));
    // this.after = this.result[this.sel].value.substring( (this.before.length + this.type_ahead.length) );
    if (this.result.length > 0 && this.type_ahead !== '') {
      this.set_result_position('up');
    }
    this.type_ahead = '';
    this.type_ahead = bckup;
  }
  bind_existing_value() {
    if (this.exsisting_value && this.exsisting_value !== '' && this.old_exsisting_value !== this.exsisting_value) {
      this.old_exsisting_value = this.exsisting_value;
      this.type_ahead = this.exsisting_value;
      this.result = [];
    }
  }
  take_value(e) {
    this.backspace = false;
    e.stopImmediatePropagation();
    if (this.result.length > 0 && this.sel >= 0) {
      this.type_ahead = this.result[this.sel][this.objectValue];
      this.return_value.key = this.result[this.sel][this.objectKey];
      this.return_value.value = this.returnWholeObject
        ? this.result[this.sel]
        : this.result[this.sel][this.objectValue];
      this.exsisting_value = this.type_ahead;
    } else {
      if (this.exsisting_value !== this.type_ahead) {
        if (this.free_entry && this.type_ahead !== '') {
          this.return_value.key = uuidv1();
          this.return_value.value = this.type_ahead;
        } else {
          this.return_value.key = '';
          this.return_value.value = '';
        }
        this.exsisting_value = this.type_ahead;
      } else {
        if (this.type_ahead === '') {
          this.return_value.key = '';
          this.return_value.value = this.type_ahead;
          this.exsisting_value = this.type_ahead;
        }
        return;
      }
    }
    this.sel = 0;
    this.result = [];
    this.emmiterReturnValue_emit();
  }
  type_results() {
    // if (this.result && this.result.length > 0 && this.type_ahead !== '') {
    //   // console.log(this.inputfield.nativeElement.getBoundingClientRect().left, this.results.nativeElement.getBoundingClientRect().left, this.inputfield.nativeElement.getBoundingClientRect().bottom, this.results.nativeElement.getBoundingClientRect().bottom);
    //   // this.renderer.setStyle(this.results.nativeElement, 'left', (parseInt(this.inputfield.nativeElement.getBoundingClientRect().left + 1)) + 'px');
    //   // this.renderer.setStyle(this.results.nativeElement, "top", (parseInt(this.inputfield.nativeElement.getBoundingClientRect().bottom + 1)) + 'px');
    // }
    if (this.time_out) {
      clearTimeout(this.time_out);
    }
    this.backspace = false;
    this.before = '';
    this.after = '';
    if (this.type_ahead !== '') {
      this.emmiterReturnString_emit();
    }
  }
  return_old_value() {
    this.type_ahead = this.exsisting_value;
    this.result = [];
    this.sel = 0;
  }
  remove_placeholder() {
    this.sel = 0;
  }
  backspace_alert() {
    this.backspace = true;
  }
  emmiterReturnValue_emit() {
    this.emmiterReturnValue.emit(this.return_value);
  }
  emmiterReturnString_emit() {
    this.emmiterReturnString.emit(this.type_ahead);
  }
}
